import { DownCircleFilled, UpCircleFilled } from '@ant-design/icons';
import useWindowDimensions from 'lib/hooks/useWindowDimensions';
import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';

type Props = {
  scrollHeight: number;
  setScrollHeight: React.Dispatch<React.SetStateAction<number>>;
};

const ScrollButtons: React.FC<Props> = ({ scrollHeight, setScrollHeight, children }) => {
  const dimensions = useWindowDimensions();
  const [y, setY] = useState(0);
  const handleScroll = useCallback((e) => {
    const collapse = e.currentTarget;
    setY(collapse.scrollTop);
  }, []);

  useEffect(() => {
    if (document.querySelector(`.ant-collapse`)) {
      setY(document.querySelector(`.ant-collapse`)!.scrollTop);
      setScrollHeight(
        document.querySelector(`.ant-collapse`)!.scrollHeight -
          document.querySelector(`.ant-collapse`)!.clientHeight
      );
      document.querySelector(`.ant-collapse`)!.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (document.querySelector(`.ant-collapse`)) {
        document.querySelector(`.ant-collapse`)!.removeEventListener('scroll', handleScroll);
      }
    };
  }, [handleScroll, setScrollHeight, dimensions.height]);

  return (
    <Container className={scrollHeight > 0 ? 'scrolling' : ''}>
      {scrollHeight > 0 && (
        <ScrollUpButton className={y === 0 ? 'disabled' : ''}>
          <span
            onClick={() => {
              let total = 0;
              const disableScroll = (e: any) => e.preventDefault();
              document
                .querySelector(`.ant-collapse`)!
                .addEventListener('mousewheel', disableScroll);
              const interval = setInterval(() => {
                document.querySelector(`.ant-collapse`)!.scrollTop -= 2;
                setY(document.querySelector(`.ant-collapse`)!.scrollTop);
                setScrollHeight(
                  document.querySelector(`.ant-collapse`)!.scrollHeight -
                    document.querySelector(`.ant-collapse`)!.clientHeight
                );
                total += 1;
                if (total >= 50) {
                  window.clearInterval(interval);
                  document
                    .querySelector(`.ant-collapse`)!
                    .removeEventListener('mousewheel', disableScroll);
                }
              }, 10);
            }}
          >
            <UpCircleFilled />
          </span>
        </ScrollUpButton>
      )}
      {children}
      {scrollHeight > 0 && (
        <ScrollDownButton className={y >= scrollHeight ? 'disabled' : ''}>
          <span
            onClick={() => {
              let total = 0;
              const disableScroll = (e: any) => e.preventDefault();
              document
                .querySelector(`.ant-collapse`)!
                .addEventListener('mousewheel', disableScroll);
              const interval = setInterval(() => {
                document.querySelector(`.ant-collapse`)!.scrollTop += 2;
                setY(document.querySelector(`.ant-collapse`)!.scrollTop);
                setScrollHeight(
                  document.querySelector(`.ant-collapse`)!.scrollHeight -
                    document.querySelector(`.ant-collapse`)!.clientHeight
                );
                total += 1;
                if (total >= 50) {
                  window.clearInterval(interval);
                  document
                    .querySelector(`.ant-collapse`)!
                    .removeEventListener('mousewheel', disableScroll);
                }
              }, 10);
            }}
          >
            <DownCircleFilled />
          </span>
        </ScrollDownButton>
      )}
    </Container>
  );
};

export default ScrollButtons;

const Container = styled.div`
  position: relative;
  .ant-collapse {
    transition: all 0.3s, visibility 0s;
    overflow: auto;
    height: 60vh;
  }
  &.scrolling {
    .ant-collapse {
      padding: 35px 0;
    }
  }
`;

export const ScrollUpButton = styled.div`
  position: absolute;
  top: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  z-index: 10;
  font-size: 25px;
  color: ${({ theme }) => theme.colors.primaryColor};
  box-shadow: inset 0px 15px 10px 0px ${({ theme }) => theme.colors.sideMenuBackgroundColor};
  transition: all 0.3s, visibility 0s;

  span {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  &.disabled {
    color: ${({ theme }) => theme.colors.buttonColorCategory};
  }
`;

export const ScrollDownButton = styled.div`
  position: absolute;
  bottom: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  z-index: 10;
  font-size: 25px;
  color: ${({ theme }) => theme.colors.primaryColor};
  box-shadow: inset 0px -15px 10px 0px ${({ theme }) => theme.colors.sideMenuBackgroundColor};
  transition: all 0.3s, visibility 0s;

  span {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  &.disabled {
    color: ${({ theme }) => theme.colors.buttonColorCategory};
  }
`;
